import { CSSProperties } from 'react';
import { colors } from '../../NewHire/v2/styles';
import { RATING_SCALE_LABELS } from '../utils/questionsCatalog';

const wrapStyle: CSSProperties = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '4px 14px',
  padding: '10px 12px',
  marginBottom: 16,
  background: colors.accentSoft,
  border: `1px solid ${colors.border}`,
  borderRadius: 8,
  fontSize: 12,
  color: colors.text,
  lineHeight: 1.4,
};

const RatingScaleLegend = () => {
  const ascending = [...RATING_SCALE_LABELS].sort((a, b) => a.value - b.value);
  return (
    <div style={wrapStyle}>
      {ascending.map((l) => (
        <span key={l.value}>
          <strong>{l.value}</strong> {l.label}
        </span>
      ))}
    </div>
  );
};

export default RatingScaleLegend;
